import { defineSlotRecipe } from '@chakra-ui/react';

export const accommodationTileSlotRecipe = defineSlotRecipe({
    slots: [
        'amenities',
        'container',
        'cta',
        'details',
        'flexDates',
        'images',
        'info',
        'price',
        'priceConfirmation',
        'promoText',
        'rating',
    ],
    base: {
        container: {
            boxShadow: 'tile',
            borderRadius: 'tile',
            columnGap: 2,
            rowGap: 3,
            gridAutoFlow: 'column',
            gridTemplateColumns: 'auto 1fr',
            pr: 2,
            md: {
                gridTemplateColumns: 'auto 1fr auto',
                rowGap: 3,
                columnGap: 4,
                pr: 4,
                pl: 4,
                py: 4,
            },
        },
        images: {
            bgColor: 'gray.200',
            w: '133px',
            gridColumn: 1,
            gridRow: '1 / 6',
            md: {
                gridRow: '1 / 5',
                w: '280px',
            },
            '& img': {
                w: 'full',
                borderRadius: {
                    base: '',
                    md: 'tileImage',
                },
                borderLeftRadius: {
                    base: 'tile',
                    md: undefined,
                },
            },
        },
        info: {
            gridColumn: 2,
            gridRow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            md: {
                gridRow: '1 / span 2',
                pt: 0,
            },
            pt: 2,
        },
        rating: {
            gridColumn: 2,
            gridRow: 2,
            md: {
                gridRow: 1,
                gridColumn: 3,
            },
        },
        amenities: {
            gridRow: 3,
            gridColumn: 2,
            md: {
                gridRow: 3,
            },
        },
        details: {
            gridColumn: 2,
            gridRow: 4,
            alignSelf: 'end',
        },
        flexDates: {},
        price: {
            gridColumn: 2,
            gridRow: 5,
            md: {
                alignSelf: 'end',
                gridRow: '2 / span 2',
                gridColumn: 3,
            },
        },
        priceConfirmation: {
            fontSize: {
                base: '13px',
                md: 'xs',
            },
            color: 'gray.500',
            textAlign: {
                base: 'left',
                md: 'right',
            },
            mb: {
                base: 0,
                md: -1.5,
            },
        },
        promoText: {
            fontSize: 'xs',
            color: 'gray.500',
            _before: {
                content: 'open-quote',
            },
            _after: {
                content: 'close-quote',
            },
        },
        cta: {
            md: {
                gridRow: 4,
                gridColumn: 3,
            },
        },
    },
    variants: {
        variant: {},
    },
});
